import styled from "styled-components";
import { Typography } from "@mui/material";

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  width: 100%;
`;

export const SearchLabel = styled.div`
  margin-bottom: 8px;
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const SearchButton = styled.button`
  background: #d33100;
  color: white;
  border: none;
  border-radius: 999px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  min-width: 100px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background: #a02500;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const ResultsSection = styled.div`
  flex: 1;
  min-height: 200px;
`;

export const ApplyButton = styled.button<{ selectedReseller: string }>`
  width: 100%;
  background: #e0e0e0;
  color: #9e9e9e;
  border: none;
  border-radius: 999px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;

  &:not(:disabled) {
    background: ${({ selectedReseller }) =>
      selectedReseller ? "#d33100" : "#e0e0e0"};
    color: white;

    &:hover {
      background: ${({ selectedReseller }) =>
        selectedReseller ? "#a02500" : "#e0e0e0"};
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ResellerItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const ResellerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResellerName = styled(Typography)`
  font-weight: 500;
  color: #333;
  font-size: 14px;
`;

export const ResellerCnpj = styled(Typography)`
  color: #666;
  font-size: 12px;
`;
